var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplyMuti(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14A7 7 0 107 0a7 7 0 000 14zm.4-11a.4.4 0 00-.664-.301l-4 3.5a.4.4 0 000 .602l4 3.5A.4.4 0 007.4 10V8.315c.442.032.963.117 1.484.274.691.208 1.354.533 1.838.999l.678.652V9.3c0-1.9-.9-3.068-1.904-3.745a5.316 5.316 0 00-2.096-.82V3zm-.8 6.118L3.607 6.5 6.6 3.88V5.1c0 .22.179.4.4.4.29 0 1.21.154 2.049.719a3.367 3.367 0 011.47 2.216 6.11 6.11 0 00-1.404-.612A7.62 7.62 0 007 7.5a.4.4 0 00-.4.4v1.218z",
    fill: "#386EE7"
  })));
}
export default __webpack_public_path__ + "static/reply_muti.b130b032.svg";
export { SvgReplyMuti as ReactComponent };